/**
 * Privacy Notice Component
 *
 * Displays:
 * - Privacy-first design notice
 * - Members can only see names/emails, not analysis content
 *
 * Presentational component: Static content
 */
import React from 'react';
import { View, Text } from 'react-native';
import type { TFunction } from '@dramadetector/shared';

interface PrivacyNoticeProps {
  t: TFunction<"subscription">;
}

export function PrivacyNotice({ t }: PrivacyNoticeProps) {
  return (
    <View className="bg-blue-50 border border-blue-200 rounded-2xl p-4 mx-6 mb-6">
      <Text className="text-blue-900 font-semibold mb-2">
        {t('family.privacyTitle')}
      </Text>
      <Text className="text-blue-800 text-sm">
        {t('family.privacyDescription')}
      </Text>
    </View>
  );
}
